function addGeoJsonWrapper(features) {
  return {
    type: "FeatureCollection",
    features: features,
  };
}

module.exports = { addGeoJsonWrapper };
